import script from "./AdminNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&setup=true&lang=js"

import "./AdminNavbar.vue?vue&type=style&index=0&id=735c871a&scoped=true&lang=css"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735c871a"]])

export default __exports__